/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * Parameter structure for flex image requests.
 *
 * TODO: Write documentation with examples.
 * TODO: Remove all unused parameters.
 * @export
 * @interface FlexImageV2RequestParamsFlexParams
 */
export interface FlexImageV2RequestParamsFlexParams {
  /**
   *
   * @type {string}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  series: string
  /**
   *
   * @type {boolean}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  useBoundingBoxes: boolean
  /**
   *
   * @type {number}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  frame?: number | null
  /**
   *
   * @type {string}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  bgColor?: string | null
  /**
   *
   * @type {string}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  bgImage?: string | null
  /**
   *
   * @type {string}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  imageType?: string | null
  /**
   *
   * @type {Array<number>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  size?: Array<number> | null
  /**
   *
   * @type {Array<number>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  minBound?: Array<number> | null
  /**
   *
   * @type {Array<number>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  sample?: Array<number> | null
  /**
   *
   * @type {Array<string>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  autoCrop?: Array<string> | null
  /**
   *
   * @type {boolean}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  skipBackgroundElementsInAutocrop?: boolean
  /**
   *
   * @type {Array<number>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  align?: Array<number> | null
  /**
   *
   * @type {Array<number>}
   * @memberof FlexImageV2RequestParamsFlexParams
   */
  margin?: Array<number> | null
}

/**
 * Check if a given object implements the FlexImageV2RequestParamsFlexParams interface.
 */
export function instanceOfFlexImageV2RequestParamsFlexParams(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'series' in value
  isInstance = isInstance && 'useBoundingBoxes' in value

  return isInstance
}

export function FlexImageV2RequestParamsFlexParamsFromJSON(
  json: any,
): FlexImageV2RequestParamsFlexParams {
  return FlexImageV2RequestParamsFlexParamsFromJSONTyped(json, false)
}

export function FlexImageV2RequestParamsFlexParamsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FlexImageV2RequestParamsFlexParams {
  if (json === undefined || json === null) {
    return json
  }
  return {
    series: json['series'],
    useBoundingBoxes: json['useBoundingBoxes'],
    frame: !exists(json, 'frame') ? undefined : json['frame'],
    bgColor: !exists(json, 'bgColor') ? undefined : json['bgColor'],
    bgImage: !exists(json, 'bgImage') ? undefined : json['bgImage'],
    imageType: !exists(json, 'imageType') ? undefined : json['imageType'],
    size: !exists(json, 'size') ? undefined : json['size'],
    minBound: !exists(json, 'minBound') ? undefined : json['minBound'],
    sample: !exists(json, 'sample') ? undefined : json['sample'],
    autoCrop: !exists(json, 'autoCrop') ? undefined : json['autoCrop'],
    skipBackgroundElementsInAutocrop: !exists(
      json,
      'skipBackgroundElementsInAutocrop',
    )
      ? undefined
      : json['skipBackgroundElementsInAutocrop'],
    align: !exists(json, 'align') ? undefined : json['align'],
    margin: !exists(json, 'margin') ? undefined : json['margin'],
  }
}

export function FlexImageV2RequestParamsFlexParamsToJSON(
  value?: FlexImageV2RequestParamsFlexParams | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    series: value.series,
    useBoundingBoxes: value.useBoundingBoxes,
    frame: value.frame,
    bgColor: value.bgColor,
    bgImage: value.bgImage,
    imageType: value.imageType,
    size: value.size,
    minBound: value.minBound,
    sample: value.sample,
    autoCrop: value.autoCrop,
    skipBackgroundElementsInAutocrop: value.skipBackgroundElementsInAutocrop,
    align: value.align,
    margin: value.margin,
  }
}
